import axios from "axios";
import qs from "qs";
import store from "./store";
import { updateStatusLogin } from "./actions/authAction";
import { SERVER_API } from "./constants/siteConfig";

const axiosInstance = axios.create({
  baseURL: SERVER_API + localStorage.SECOLAH_CODE + "/apischool/",
  params: {},
  paramsSerializer: function (params) {
        return qs.stringify({
                id: store.getState().authReducer.user_id
            }, {arrayFormat: 'brackets'})
  },
  validateStatus: function (status) {
    return (status >= 200 && status < 300) || status === 422;
  },
  transformResponse: [
    function (data) {
      // ubah ke json karena "data" berbentuk string
      const JSONResponse = JSON.parse(data);

      if (JSONResponse.auth === "failed") {
        // dispatch action redux
        store.dispatch(updateStatusLogin(false, "", "", "", "", "", ""));
      } else {
        return JSONResponse;
      }
    },
  ],
});
export default axiosInstance;



// WEBPACK FOOTER //
// ./src/axios.js